import { render } from "./CategoryTitle.vue?vue&type=template&id=b7d42aea&scoped=true"
import script from "./CategoryTitle.vue?vue&type=script&lang=js"
export * from "./CategoryTitle.vue?vue&type=script&lang=js"

import "./CategoryTitle.vue?vue&type=style&index=0&id=b7d42aea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d42aea"]])

export default __exports__